import DolliesProducts from './DolliesProducts';

export default DolliesProducts;
